import { render, staticRenderFns } from "./AddDeparmentComponent.vue?vue&type=template&id=797fb3d9"
import script from "./AddDeparmentComponent.vue?vue&type=script&lang=js"
export * from "./AddDeparmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports